export default __webpack_public_path__ + "static/media/step11.3cd059f7.png";